import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { SetCredentialsAction } from 'src/app/angular-wallet-base/actions/accountSetup.actions';
import { SKIP_INTRO_PAGE_KEY } from 'src/app/angular-wallet-base/constants';
import { AuthGuardService } from 'src/app/angular-wallet-base/services/auth-guard.service';
import { StorageService } from 'src/app/angular-wallet-base/services/storage.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/angular-wallet-base/store/appState';
@Component({
  selector: 'app-intro3',
  templateUrl: './intro3.page.html',
  styleUrls: ['./intro3.page.scss'],
})
export class Intro3Page implements OnInit {

  public backButton = true;

  constructor(
    private nav: NavController,
    private storage: StorageService,
    protected store: Store<AppState>,
    private authGuardService: AuthGuardService,
  ) {
  }

  async ngOnInit() {
    this.backButton = ! await this.storage.get(SKIP_INTRO_PAGE_KEY);
    this.authGuardService.setNewUserData('');
    this.authGuardService.setUserEmailActivateStatus('');
  }

  async toPage(url: string) {
    this.authGuardService.setNewUserData('');
    this.authGuardService.setUserEmailActivateStatus('');
    this.store.dispatch(new SetCredentialsAction({email: '',password: ''}));  // Clearing email data after initial page
    await this.storage.set(SKIP_INTRO_PAGE_KEY, true);
    this.nav.navigateForward(url);
  }

}
